module.exports = __webpack_public_path__ + "static/media/ali.91e123d9.jpg";